import Vue from 'vue'
import Vuex from 'vuex'

import common from './common'
import auth from './authModule'
import project from './project'
import advancedWeldLog from './advancedWeldLog'
import flexAccount from './flexAccount'
import overtime from './overtime'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    auth,
    project,
    advancedWeldLog,
    flexAccount,
    overtime
  }
})
